import { render, staticRenderFns } from "./MedicationCategoriesSection.vue?vue&type=template&id=34a4b2d6"
import script from "./MedicationCategoriesSection.vue?vue&type=script&lang=js"
export * from "./MedicationCategoriesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports